/**
 * Brand mark for the in-app header. Mirrors public/favicon.svg verbatim
 * so the tab icon and the on-page logo are visually identical — when the
 * favicon design changes, update this file in lockstep.
 *
 * Renders only the artwork; the indigo gradient square that wraps it in
 * the favicon SVG is replaced here by the surrounding Tailwind
 * `rounded-xl bg-gradient-to-br ...` element in App.tsx, which already
 * provides the indigo background. Drawing it twice would double up the
 * shadow and clip the rounded corners.
 */

interface Props {
  className?: string;
}

export function BrandMark({ className }: Props): JSX.Element {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label="Receipt Ripper"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="rr-paper" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#eef2ff" />
        </linearGradient>
      </defs>

      <path
        d="M9 5 L23 5 L23 23 L20.5 27 L18 23 L15.5 27 L13 23 L10.5 27 L9 23 Z"
        fill="url(#rr-paper)"
      />

      <rect x="11" y="7.5" width="10" height="1.8" rx="0.6" fill="#4338ca" />

      <line x1="11" y1="13" x2="21" y2="13" stroke="#4338ca" strokeWidth="1.4" strokeLinecap="round" />
      <line x1="11" y1="16" x2="19" y2="16" stroke="#4338ca" strokeWidth="1.4" strokeLinecap="round" />
      <line x1="11" y1="19" x2="21" y2="19" stroke="#4338ca" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}
